import { defineComponent as _defineComponent } from 'vue'
import FiltersDialog from "@/components/base/filters/FiltersDialog.vue";
import FiltersDesign from "@/components/base/filters/FiltersDesign.vue";
import { computed, onBeforeMount, ref } from "vue";
import { EUAccountsFilters } from "@/services/TablePage/euAccounts";
import store from "@/store";
import { useEUAccountsStore } from "@/store_v3/EUAccountsStore";
import { delay } from "@/utils";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'EUAccountsFilters',
  setup(__props) {

const getWidth = computed(() => 340);

const isShowFilters = ref(false);
const filters = ref<EUAccountsFilters>(null);
const { updateEUAccountsListFlag } = storeToRefs(useEUAccountsStore());

onBeforeMount(() => {
    store.commit('SET_FILTERS_PARAMS_OBJECT', {});
    store.commit('SET_DEFAULT_FILTERS_PARAMS_OBJECT', {});
    filters.value = new EUAccountsFilters();
    filters.value.setDefaultFilters();
    initTargetFilters();
});

const initTargetFilters = async () => {
    await delay(100);
};

const submitFilters = () => {
    updateEUAccountsListFlag.value = true;
    isShowFilters.value = false;
};

const clearFilters = () => {
    updateEUAccountsListFlag.value = true;
    filters.value.parseRoute();
};


return { __sfc: true,getWidth, isShowFilters, filters, updateEUAccountsListFlag, initTargetFilters, submitFilters, clearFilters, FiltersDialog, FiltersDesign }
}

})